/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2023-04-05 20:09:14
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2024-03-21 15:25:00
 * FilePath     :\AV-COM-user-backend\src\directives\index.js
 * RevisionHistory:
 */
// import tableHeight from "./table-height";
import store from "@/store/index";
import { roleMap } from "@/utils/type-map";

export const userP = {
    inserted(el, binding) {
        const { value } = binding;
        // const userPermissions = roleMap[2];
        const userPermissions =
            roleMap[store.state.enterprise?.GROUP_LIST[0].userPermissions];
        var hasPermissions = value.indexOf(userPermissions) > -1;
        if (!hasPermissions) {
            el.parentNode && el.parentNode.removeChild(el);
        }
    },
};
export const deviceP = {
    inserted(el, binding) {
        const { value } = binding;
        // const devicePermissions = roleMap[2];
        const devicePermissions =
            roleMap[store.state.enterprise?.GROUP_LIST[0].devicePermissions];
        var hasPermissions = value.indexOf(devicePermissions) > -1;
        if (!hasPermissions) {
            el.parentNode && el.parentNode.removeChild(el);
        }
    },
};
